import React from 'react';
import './EnglishTyping.css';

const EnglishTyping = ({
  input,
  setInput,
  started,
  setStarted,
  selectedParagraph,
  calculateMetrics,
  handleTestComplete,
  setKeyCount,
  textareaRef,
  paragraphRef
}) => {

  const handleChange = (e) => {
    let value = e.target.value;

    // ✅ Start test on first input
    if (!started && value.length > 0) {
      document.documentElement.requestFullscreen().catch(() => {});
      setStarted(true);
    }

    // ✅ Allow everything, filter later (DON'T BLOCK INPUT)
    // Just trim extra length
    if (value.length > selectedParagraph.length) {
      value = value.slice(0, selectedParagraph.length);
    }

    setInput(value);
    calculateMetrics(value);

    // ✅ Auto complete
    if (value.length === selectedParagraph.length) {
      handleTestComplete();
    }
  };

  const handleKeyDown = (e) => {

    // ✅ Only block dangerous shortcuts
    if (
      (e.ctrlKey || e.metaKey) &&
      ["a", "c", "v", "x"].includes(e.key.toLowerCase())
    ) {
      e.preventDefault();
    }

    // ❌ REMOVE arrow restrictions (causes lag/bugs)

    // ✅ Count keys properly
    if (
      e.key.length === 1 ||
      e.key === "Backspace" ||
      e.key === "Enter" ||
      e.key === " "
    ) {
      setKeyCount(prev => prev + 1);
    }
  };

  // ✅ Smooth scroll (separate effect = no lag)
  React.useEffect(() => {
    if (!paragraphRef.current) return;

    const progress = input.length / selectedParagraph.length;
    const maxScroll =
      paragraphRef.current.scrollHeight -
      paragraphRef.current.clientHeight;

    paragraphRef.current.scrollTop = maxScroll * progress;
  }, [input, selectedParagraph, paragraphRef]);

  return (
    <textarea
      ref={textareaRef}
      value={input}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={
        started
          ? "Continue typing..."
          : "Start typing here to begin test..."
      }
      className="typing-inputenglish"
      spellCheck={false}

      // ✅ Anti-cheat but safe
      onPaste={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}

      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
    />
  );
};

export default EnglishTyping;